const currencyMap = {
  "20": "en-us",  // USD
  "1": "en-au",   // AUD
  "12": "en-nz",  // NZD
  "4": "en-ca"    // CAD
} as Record<string, string>;

const DEFAULT_CURRENCY_ID = "20"; // Default to USD


const getCurrencyIdFromLocale = (locale: string): string => {
  const normalizedLocale = locale.toLowerCase().trim();
  const entry = Object.entries(currencyMap)
    .find(([, localeValue]) => localeValue === normalizedLocale);

  return entry ? entry[0] : DEFAULT_CURRENCY_ID;
};

export default getCurrencyIdFromLocale;